// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.applied-actions[data-v-eaa53168] {\n  display: block;\n  max-width: 265px;\n  margin-top: 30px;\n}\n.applied-actions__withdraw-btn[data-v-eaa53168],\n.applied-actions__award-btn-cont[data-v-eaa53168] {\n  margin-bottom: 20px;\n}\n@media (max-width: 767px) {\n.applied-actions[data-v-eaa53168] {\n    max-width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
